import React from 'react';

const PlayBtn = () => {
  return (
    <svg width='100%' height='100%' viewBox='0 0 84 90' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.6'
        d='M0.25 88.6986V0.529427L83.4658 42.1186L0.25 88.6986Z'
        fill='#D9D9D9'
        stroke='black'
        strokeWidth='0.5'
      />
    </svg>
  );
};

export default PlayBtn;
